import AbstractStore from 'core/abstracts/AbstractStore';
import Dispatcher from 'core/Dispatcher';

class LayoutStore extends AbstractStore {

    constructor() {

        const CHANGE_EVENT = 'LAYOUT_CHANGE_EVENT';
        const NAME = 'LAYOUT_STORE';

        super(NAME, CHANGE_EVENT);

        this._initStore();

        // Registers action handler with the Dispatcher.
        Dispatcher.register(this._registerToActions.bind(this));
    }

    _initStore() {
        this.height = window.innerHeight;
        this.width = window.innerWidth;

        this.isLoading = false;

        this.mobile = false;
        if (this.width < 600)
            this.mobile = true;

        // add windows size listener for mobile
        window.addEventListener('resize', this.onScreenSizeChange);
    }

    onScreenSizeChange = () => {
        this.height = window.innerHeight;
        this.width = window.innerWidth;

        if (this.width < 600) {
            this.mobile = true;
        } else {
            this.mobile = false;
        }

        this._emitChange();
    };

    isMobile() {
        return this.mobile;
    }

    getZise() {
        return {
            width: this.width,
            height: this.height
        };
    }

    // Switches over the action's type when an action is dispatched.
    _registerToActions(action) {
        switch (action.actionType) {
        default:
            return false;
        }
    }
}

export default new LayoutStore();
